<template>
  <section>
    <Title :title-name="pageTitle.titleName" :title-link="pageTitle.titleLink" />
    <div v-if="lang && pax && pax['covid19_portal'] && pax['covid19_portal']['1'] && lang['homepage_new']" class="index">
      <div class="container">
        <!--WELCOME-->
        <div v-if="airline.covid19_config && isEnabledCovidConfig('WELCOME')" class="wellcome-text">
          <h2 class="title fontsize-title">
            {{ pax['covid19_portal'][1].WELCOME_TITLE }}
          </h2>
          <div class="content-wellcome-text mb-3">
            <div>
              <div v-if="!showMore" v-html="pax['covid19_portal'][1].WELCOME.substring(0, 100) + '...'"></div>
              <div v-else v-html="pax['covid19_portal'][1].WELCOME"></div>
            </div>
            <div class="text-right">
              <span v-if="!showMore" class="cursor" @click="showMoreText()">{{ pax['covid19_portal'][1].READ_MORE }}</span>
              <span v-else class="cursor" @click="showMoreText()">{{ pax['covid19_portal'][1].READ_LESS }}</span>
            </div>
          </div>
        </div>
        <!--/WELCOME-->
        <!--FLIGHT-->
        <h2
          v-if="
            airline.lang_config &&
            isEnabledConfig('SFS_LANG_ROW_3') &&
            airline.covid19_config &&
            isEnabledCovidConfig('FLIGHT_INFORMATION')
          "
          class="title fontsize-title"
        >
          {{ pax['covid19_portal'][1].FLIGHT_INFORMATION }}
        </h2>
        <div
          v-if="
            Flight &&
            airline.lang_config &&
            airline.covid19_config &&
            isEnabledCovidConfig('FLIGHT_INFORMATION') &&
            isEnabledConfig('SFS_LANG_ROW_32')
          "
          class="block-item row btn-select mr-0 ml-0"
          style="margin-bottom: 15pt"
        >
          <div class="container">
            <div class="row flightinfo text-center">
              <div class="col-4">
                <div>{{ lang['homepage_new'].SFS_LANG_ROW_1 }}</div>
                <div class="airport-name">{{ Flight.dep }}</div>
                <div class="flight-time-der">
                  {{ moment(Flight.std).format('D MMM') }}
                  <div :style="Flight.etd ? 'text-decoration: line-through' : ''">
                    {{ moment(Flight.std).format('HH:mm') }}
                  </div>
                  <div v-if="Flight.etd">
                    {{ moment(Flight.etd).format('HH:mm') }}
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div>{{ Flight.carrier }}{{ Flight.flight_no }}</div>
                <div class="frame-flight-img" style="margin-top: 11pt">
                  <img src="@/assets/images/flight.png" />
                </div>
                <div class="flight-status">
                  <p style="color: #000">{{ lang['homepage_new'].SFS_LANG_ROW_3 }}:</p>
                  <p v-if="pax.fltref !== pax.first_fltref" :class="{ 'status-new-flight': pax.fltref !== pax.first_fltref }">
                    {{ statusFlight }}
                  </p>
                  <p v-else class="status-flight">
                    <span v-if="Flight.irreg_reason">{{
                      lang['status_flight'][Flight.irreg_reason] || Flight.flight_status
                    }}</span>
                    <span v-else>{{ lang['status_flight']['NO_IRREG'] || Flight.flight_status }}</span>
                  </p>
                  <p v-if="statusFlightDetail">{{ statusFlightDetail }}</p>
                </div>
              </div>
              <div class="col-4">
                <div>{{ lang['homepage_new'].SFS_LANG_ROW_2 }}</div>
                <div class="airport-name">{{ Flight.div }}</div>
                <div class="flight-time-arr">
                  {{ moment(Flight.sta).format('D MMM') }}
                  <div :style="Flight.eta ? 'text-decoration: line-through' : ''">
                    {{ moment(Flight.sta).format('HH:mm') }}
                  </div>
                  <div v-if="Flight.eta">
                    {{ moment(Flight.eta).format('HH:mm') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--COVID-19-->
        <div v-if="pax['covid19_portal'][1]" class="container">
          <h2 v-if="airline.covid19_config && isEnabledCovidConfig('PERSONAL_FLIGHT')" class="title fontsize-title">
            {{ pax['covid19_portal'][1].PERSONAL_FLIGHT }}
          </h2>
          <div v-if="airline.covid19_config && isEnabledCovidConfig('PERSONAL_FLIGHT')" class="block-item row btn-select">
            <router-link class="col-12" :to="{ name: 'MyFlightUpdates', query: { secret: secret } }">
              <div class="row align-items-center">
                <div class="col-3 col-md-2">
                  <i class="sb_mobile sb_flight_blue text-right">
                    <i v-if="countNewMsg > 0" class="badge badge-pill badge-danger" style="font-size: 9pt">{{ countNewMsg }}</i>
                  </i>
                </div>
                <div class="item-title col-8 col-md-9">
                  <span v-if="listMessage.length > 0">
                    {{ pax['covid19_portal'][1].PERSONAL_FLIGHT_1 }}
                    {{ newDateFlight ? moment(newDateFlight).format('DD-MM-YYYY') : '' }}
                  </span>
                  <span v-else> No infomation update </span>
                </div>
                <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
              </div>
            </router-link>
          </div>
          <h2 v-if="airline.covid19_config && isEnabledCovidConfig('PERSONAL_DETAILS')" class="title fontsize-title">
            {{ pax['covid19_portal'][1].PERSONAL_DETAILS }}
          </h2>
          <div v-if="airline.covid19_config && isEnabledCovidConfig('PERSONAL_DETAILS')" class="block-item row btn-select">
            <router-link class="col-12" :to="{ name: 'PersonalDetails', query: { secret: secret } }">
              <div class="row align-items-center">
                <div class="col-3 col-md-2">
                  <i class="sb_mobile sb_personal text-right"> </i>
                </div>
                <div class="item-title col-8 col-md-9">
                  <span class="mr-5">{{ pax.full_name }}</span>
                  <span>PNR: {{ pax.pnr }}</span>
                </div>
                <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
              </div>
            </router-link>
          </div>
          <div v-if="airline.covid19_config && isEnabledCovidConfig('MY_DOCUMENTS') && pax.document && pax.document.length > 0">
            <h2 class="title fontsize-title">{{ pax['covid19_portal'][1].MY_DOCUMENTS }}</h2>
            <div class="block-item row btn-select">
              <router-link class="col-12" :to="{ name: 'MyDocument', query: { secret: secret } }">
                <div class="row align-items-center">
                  <div class="col-3 col-md-2">
                    <i class="sb_mobile sb_document text-right"> </i>
                  </div>
                  <div class="item-title col-8 col-md-9">
                    {{ pax['covid19_portal'][1].MY_DOCUMENTS_1 }}
                  </div>
                  <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
                </div>
              </router-link>
            </div>
          </div>
          <h2 v-if="airline.covid19_config && isEnabledCovidConfig('REBOOK_FLIGHT')" class="title fontsize-title">
            {{ pax['covid19_portal'][1].REBOOK_FLIGHT }}
          </h2>
          <div v-if="airline.covid19_config && isEnabledCovidConfig('REBOOK_FLIGHT')" class="block-item row btn-select">
            <a class="col-12" :href="pax['covid19_portal'][2].URL" target="_blank">
              <div class="row align-items-center">
                <div class="col-3 col-md-2">
                  <i class="sb_mobile sb_rebook text-right"> </i>
                </div>
                <div class="item-title col-8 col-md-9">
                  <div
                    v-if="pax['covid19_portal'][1].REBOOK_FLIGHT_1.indexOf(['<airport_code>']) >= 0"
                    v-html="replaceStr(pax['covid19_portal'][1].REBOOK_FLIGHT_1, ['<airport_code>'], pax.arr)"
                  ></div>
                  <div v-else>{{ pax['covid19_portal'][1].REBOOK_FLIGHT_1 }}</div>
                </div>
                <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
              </div>
            </a>
          </div>
          <h2 v-if="airline.covid19_config && isEnabledCovidConfig('SHARE_FLIGHT')" class="title fontsize-title">
            {{ pax['covid19_portal'][1].SHARE_FLIGHT }}
          </h2>
          <div v-if="airline.covid19_config && isEnabledCovidConfig('SHARE_FLIGHT')" class="block-item row btn-select">
            <router-link class="col-12" :to="{ name: 'ShareFlight', query: { secret: secret } }">
              <div class="row align-items-center">
                <div class="col-3 col-md-2">
                  <i class="sb_mobile sb_share text-right"> </i>
                </div>
                <div class="item-title col-8 col-md-9">
                  {{ pax['covid19_portal'][1].SHARE_FLIGHT_1 }}
                </div>
                <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
              </div>
            </router-link>
          </div>
          <h2 v-if="airline.covid19_config && isEnabledCovidConfig('GENERAL_INFORMATION')" class="title fontsize-title">
            {{ pax['covid19_portal'][1].GENERAL_INFORMATION }}
          </h2>
          <template v-for="(item, index) in pax['covid19_portal']">
            <div
              v-if="airline.covid19_config && isEnabledCovidConfig('GENERAL_INFORMATION') && index > 2"
              :key="index"
              class="block-item row btn-select"
            >
              <router-link
                v-if="parseInt(item['USE_URL_' + pax.arr]) == 1"
                class="col-12"
                :to="{ name: 'IframePopup', query: { secret: secret, url: item['URL_' + pax.arr] } }"
              >
                <div class="row align-items-center">
                  <div class="col-3 col-md-2">
                    <i class="sb_mobile text-right" :class="item['ICON_' + pax.arr] || item.ICON"> </i>
                  </div>
                  <div class="item-title col-8 col-md-9">
                    <div
                      v-if="
                        item.TITLE.indexOf(['<airline_name>']) >= 0 ||
                        (item['TITLE_' + pax.arr] && item['TITLE_' + pax.arr].indexOf(['<airline_name>']) >= 0)
                      "
                      v-html="replaceStr(item['TITLE_' + pax.arr] || item.TITLE, ['<airline_name>'], airline.name)"
                    ></div>
                    <div
                      v-else-if="
                        item.TITLE.indexOf(['<airport_code>']) >= 0 ||
                        (item['TITLE_' + pax.arr] && item['TITLE_' + pax.arr].indexOf(['<airport_code>']) >= 0)
                      "
                      v-html="replaceStr(item['TITLE_' + pax.arr] || item.TITLE, ['<airport_code>'], pax.arr)"
                    ></div>
                    <div v-else v-html="item['TITLE_' + pax.arr] || item.TITLE"></div>
                  </div>
                  <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
                </div>
              </router-link>
              <router-link
                v-if="!item['USE_URL_' + pax.arr] || parseInt(item['USE_URL_' + pax.arr]) == 0"
                class="col-12"
                :to="{ name: 'GeneralInfomation', query: { secret: secret, key: index } }"
              >
                <div class="row align-items-center">
                  <div class="col-3 col-md-2">
                    <i class="sb_mobile text-right" :class="item['ICON_' + pax.arr] ? item['ICON_' + pax.arr] : item.ICON"> </i>
                  </div>
                  <div class="item-title col-8 col-md-9">
                    <div
                      v-if="
                        (item.TITLE && item.TITLE.indexOf(['<airline_name>']) >= 0) ||
                        (item['TITLE_' + pax.arr] && item['TITLE_' + pax.arr].indexOf(['<airline_name>']) >= 0)
                      "
                      v-html="replaceStr(item['TITLE_' + pax.arr] || item.TITLE, ['<airline_name>'], airline.name)"
                    ></div>
                    <div
                      v-else-if="
                        (item.TITLE && item.TITLE.indexOf(['<airport_code>']) >= 0) ||
                        (item['TITLE_' + pax.arr] && item['TITLE_' + pax.arr].indexOf(['<airport_code>']) >= 0)
                      "
                      v-html="replaceStr(item['TITLE_' + pax.arr] || item.TITLE, ['<airport_code>'], pax.arr)"
                    ></div>
                    <div v-else v-html="item['TITLE_' + pax.arr] || item.TITLE"></div>
                  </div>
                  <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
                </div>
              </router-link>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Title from '@/components/Title/index'
import { mapGetters } from 'vuex'
import '@/assets/scss/modules/Home.scss'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'CovidPortal',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      statusFlightDetail: '',
      pageTitle: {},
      newDateFlight: null,
      showServicesSection: '',
      listMessage: [],
      countNewMsg: 0,
      showMore: false
    }
  },
  computed: {
    ...mapGetters({
      Flight: 'Flight/Flight',
      DataMsg: 'MessagesList/Cmtpax',
      PaxsGroup: 'Home/PaxsGroup'
    })
  },
  watch: {
    title: function (el) {
      if (el && el.CovidPortal) {
        this.pageTitle = el.CovidPortal
      }
    },
    DataMsg: function (el) {
      if (el && el.length > 0) {
        this.listMessage = _.filter(this.DataMsg, function (o) {
          return o.sms_with_content == 1 && o.status == 2
        })
        if (this.listMessage.length > 0) {
          this.newDateFlight = this.listMessage[0].created
          this.countNewMsg = this.listMessage.filter((d) => d.has_read > 0).length
        }
      }
    },
    Flight: function (newFlight) {
      if (!_.isEmpty(this.pax) && !_.isEmpty(this.lang)) {
        this.setStatusFlight(newFlight)
      }
    },
    lang: function () {
      if (!_.isEmpty(this.Flight) && !_.isEmpty(this.pax)) {
        this.setStatusFlight(this.Flight)
      }
    },
    pax: function () {
      if (!_.isEmpty(this.Flight) && !_.isEmpty(this.lang)) {
        this.setStatusFlight(this.Flight)
      }
    }
  },
  created() {
    this.$router.push({ path: '/home', query: { secret: this.secret } })
    this.$store.dispatch('Flight/getFlight')
    this.$store.dispatch('MessagesList/getCmtpax')
    this.$store.dispatch('Home/getPaxsGroup')
    if (this.title && this.title.CovidPortal) {
      this.pageTitle = this.title.CovidPortal
    }
    if (this.DataMsg && this.DataMsg.length > 0) {
      this.listMessage = _.filter(this.DataMsg, function (o) {
        return o.sms_with_content == 1 && o.status == 2
      })
      if (this.listMessage.length > 0) {
        this.newDateFlight = this.listMessage[0].created
        this.countNewMsg = this.listMessage.filter((d) => d.has_read > 0).length
      }
    }
  },
  methods: {
    replaceStr,
    isEnabledConfig(key, type = 'homepage') {
      let row = _.find(this.airline.lang_config[type].CONFIG, { key: key })
      return !_.isUndefined(row) ? row.enabled : false
    },
    isEnabledCovidConfig(key, type = 1) {
      let row = _.find(this.airline.covid19_config[type].CONFIG, { key: key })
      return !_.isUndefined(row) ? row.enabled : false
    },
    showMoreText() {
      this.showMore = !this.showMore
    },
    setStatusFlight(newFlight) {
      let self = this
      if (_.isUndefined(self.lang['status_flight'])) {
        return
      }

      if (self.pax.fltref !== self.pax.first_fltref) {
        self.statusFlight = self.lang['status_flight']['NEW_FLIGHT']
        return
      }

      if (!newFlight.irreg_reason) {
        this.statusFlight = self.lang['status_flight']['NO_IRREG']
      } else {
        if (newFlight.irreg_reason) {
          this.statusFlight = self.lang['status_flight'][newFlight.irreg_reason]
        }
        if (newFlight.irreg_reason === 'DLY') {
          if (!_.isEmpty(std) && !_.isEmpty(etd)) {
            var std = this.moment(newFlight.std)
            var etd = this.moment(newFlight.etd)
            var time = this.moment.utc(etd.diff(std)).format('H:mm')
            this.statusFlight = self.lang['status_flight'][newFlight.irreg_reason]
            this.statusFlightDetail = _.replace(self.lang['homepage_new'].SFS_LANG_ROW_15, '<delay_time>', time)
          }
        }
        if (newFlight.irreg_reason === 'DIV') {
          this.statusFlight = self.lang['status_flight'][newFlight.irreg_reason]
          this.statusFlightDetail = _.replace(self.lang['homepage_new'].SFS_LANG_ROW_16, '<airport_name>', newFlight.arr)
        }
      }
    }
  }
}
</script>
